<template>
  <form id="login" @submit.prevent="onFirstTimeReset()" method="post">
    <h2>{{ $t('password_input') }}</h2>
      <p class="small-txt mb10">{{ $t('please_enter_your_official_password') }}</p>
      <input
        type="password"
        class="mb10"
        v-model="reset.password"
        :class="[$v.reset.password.$error ? 'pwd-error' : '']"
      >
      <div v-if="submitted && $v.reset.password.$error">
        <p class="error-txt mb20" v-if="!$v.reset.password.required">{{ $t('please_enter_your_official_password') }}</p>
        <p class="error-txt mb20" v-else>{{ $t('input_format') }}</p>
      </div>

      <p class="small-txt mb10">{{ $t('confirm_the_official_password') }}</p>
      <input
        type="password"
        class="mb10"
        v-model="reset.confirmpassword"
        :class="[$v.reset.confirmpassword.$error ? 'pwd-error' : '']"
      >
      <div v-if="submitted && $v.reset.confirmpassword.$error">
        <p class="error-txt mb20" v-if="!$v.reset.confirmpassword.required">{{ $t('please_enter_the_confirmation_for_the_official_password') }}</p>
        <p class="error-txt mb20" v-else>{{ $t('the_passwords_do_not_match') }}</p>
      </div>
      <div class="login-checkbox-area mb20">
        <label>
          <input type="checkbox" name="checkbox[]" class="checkbox-input" v-model="reset.agreed">
          <span class="checkbox-parts" v-html="$t('agree_to_terms_of_service')"></span>
        </label>
      </div>
      <div v-if="submitted && $v.reset.agreed.$error">
        <p class="error-txt mb20" v-if="!$v.reset.agreed.checked">{{ $t('please_agree_to_the_terms_of_use') }}</p>
      </div>
      <p class="error-txt mb10">{{ errorFirstResetPassword }}</p>

      <button class="btn-base mb20" type="submit" style="border: #ffa300"><a><p>{{ $t('resetting_a_password') }}</p></a></button>
      <div class="btn-cancel" @click="onCancel()"><a href="javascript:;"><p>{{ $t('cancel') }}</p></a></div>
  </form>
</template>

<script>
  import { required, minLength, maxLength, sameAs } from "vuelidate/lib/validators"
  import checkStrengthPassword from '@/js/commons/checkStrengthPassword'
  import { Strings } from "@/js/commons/strings"
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        Strings: Strings,
        reset: {
          email: '',
          oldpassword: '',
          password: '',
          confirmpassword: '',
          agreed: false
        },
        submitted: false
      }
    },
    validations: {
      reset: {
        password: { required, checkStrengthPassword },
        confirmpassword: { required, sameAsPassword: sameAs('password') },
        agreed: { checked: value => value === true }
      }
    },
    computed: {
      ...mapState({
        errorFirstResetPassword: state => state.auth.errorFirstResetPassword
      })
    },
    mounted() {
      this.screenTracking(this.$t('pw_reset_temporary_password'))
      const resetInfo = this.$store.state.auth.resetInfo
      if (resetInfo.email && resetInfo.password) {
        this.reset.email = resetInfo.email,
        this.reset.oldpassword = resetInfo.password
      } else {
        this.$router.push({ path: "/login" }).catch(err => {})
      }
    },
    methods: {
      onFirstTimeReset() {
        this.submitted = true
        this.$v.reset.$touch()
        if (this.$v.reset.$error) {
          return
        } else {
          const params = {
            email: this.reset.email,
            previouspassword: this.reset.oldpassword,
            proposedpassword: this.reset.password
          }
          this.$store.dispatch('auth/firstResetPassword', params)
            .then(response => {
              this.$store.dispatch('auth/setResetInfo', {})
              this.$router.push({ path: "/login", query: { email: this.reset.email } }).catch(err => {})
            })
        }
      },
      onCancel() {
        this.$store.dispatch('auth/setResetInfo', {})
        this.$router.push({ path: '/login' }).catch(err => {})
      },
    }
  }
</script>